__turbopack_context__.v({
  "backdrop": "VideoCards-module-scss-module__7saJxG__backdrop",
  "card": "VideoCards-module-scss-module__7saJxG__card",
  "cardContent": "VideoCards-module-scss-module__7saJxG__cardContent",
  "cardHeading": "VideoCards-module-scss-module__7saJxG__cardHeading",
  "cardList": "VideoCards-module-scss-module__7saJxG__cardList",
  "closeButton": "VideoCards-module-scss-module__7saJxG__closeButton",
  "closeIcon": "VideoCards-module-scss-module__7saJxG__closeIcon",
  "contentColumn": "VideoCards-module-scss-module__7saJxG__contentColumn",
  "cta": "VideoCards-module-scss-module__7saJxG__cta",
  "ctaIcon": "VideoCards-module-scss-module__7saJxG__ctaIcon",
  "expandButton": "VideoCards-module-scss-module__7saJxG__expandButton",
  "infoCard": "VideoCards-module-scss-module__7saJxG__infoCard",
  "mediaAsset": "VideoCards-module-scss-module__7saJxG__mediaAsset",
  "mediaAssetWrapper": "VideoCards-module-scss-module__7saJxG__mediaAssetWrapper",
  "mediaFrame": "VideoCards-module-scss-module__7saJxG__mediaFrame",
  "mobile": "VideoCards-module-scss-module__7saJxG__mobile",
  "overlayBody": "VideoCards-module-scss-module__7saJxG__overlayBody",
  "overlayPanel": "VideoCards-module-scss-module__7saJxG__overlayPanel",
  "screenReaderOnly": "VideoCards-module-scss-module__7saJxG__screenReaderOnly",
  "shortDescription": "VideoCards-module-scss-module__7saJxG__shortDescription",
  "stack-module-0": "VideoCards-module-scss-module__7saJxG__stack-module-0",
  "stack-module-1": "VideoCards-module-scss-module__7saJxG__stack-module-1",
  "stack-module-10": "VideoCards-module-scss-module__7saJxG__stack-module-10",
  "stack-module-11": "VideoCards-module-scss-module__7saJxG__stack-module-11",
  "stack-module-12": "VideoCards-module-scss-module__7saJxG__stack-module-12",
  "stack-module-13": "VideoCards-module-scss-module__7saJxG__stack-module-13",
  "stack-module-14": "VideoCards-module-scss-module__7saJxG__stack-module-14",
  "stack-module-15": "VideoCards-module-scss-module__7saJxG__stack-module-15",
  "stack-module-16": "VideoCards-module-scss-module__7saJxG__stack-module-16",
  "stack-module-17": "VideoCards-module-scss-module__7saJxG__stack-module-17",
  "stack-module-18": "VideoCards-module-scss-module__7saJxG__stack-module-18",
  "stack-module-19": "VideoCards-module-scss-module__7saJxG__stack-module-19",
  "stack-module-2": "VideoCards-module-scss-module__7saJxG__stack-module-2",
  "stack-module-20": "VideoCards-module-scss-module__7saJxG__stack-module-20",
  "stack-module-3": "VideoCards-module-scss-module__7saJxG__stack-module-3",
  "stack-module-4": "VideoCards-module-scss-module__7saJxG__stack-module-4",
  "stack-module-5": "VideoCards-module-scss-module__7saJxG__stack-module-5",
  "stack-module-6": "VideoCards-module-scss-module__7saJxG__stack-module-6",
  "stack-module-7": "VideoCards-module-scss-module__7saJxG__stack-module-7",
  "stack-module-8": "VideoCards-module-scss-module__7saJxG__stack-module-8",
  "stack-module-9": "VideoCards-module-scss-module__7saJxG__stack-module-9",
  "title": "VideoCards-module-scss-module__7saJxG__title",
  "toggleIcon": "VideoCards-module-scss-module__7saJxG__toggleIcon",
  "videoCards": "VideoCards-module-scss-module__7saJxG__videoCards",
  "wrapper": "VideoCards-module-scss-module__7saJxG__wrapper",
  "z-base": "VideoCards-module-scss-module__7saJxG__z-base",
  "z-content": "VideoCards-module-scss-module__7saJxG__z-content",
  "z-footer": "VideoCards-module-scss-module__7saJxG__z-footer",
  "z-header": "VideoCards-module-scss-module__7saJxG__z-header",
  "z-hero": "VideoCards-module-scss-module__7saJxG__z-hero",
  "z-logo": "VideoCards-module-scss-module__7saJxG__z-logo",
  "z-logo-effect": "VideoCards-module-scss-module__7saJxG__z-logo-effect",
  "z-navigation": "VideoCards-module-scss-module__7saJxG__z-navigation",
  "z-sub": "VideoCards-module-scss-module__7saJxG__z-sub",
});
